module.exports = __webpack_public_path__ + "img/event-ic-widget-01.1c32d1a7.png";